const getTipoEnderecoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
];

export default getTipoEnderecoFilterFields;
